export default "__VITE_ASSET__D0c7sVdu__"